














import { SupportPlanService } from '../../biz/remote/SupportPlanService';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dayjs, DW_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { PlanTarget } from '../../../src_server/entity/generated/PlanTarget';
import { SupportPlanConst } from '../../../src_server/entity/master/SupportPlanConst';
@Component({
  components: {},
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DW_FORMAT_JA);
    },
  },
})
export default class TermTargetPanel extends Vue {
  @Prop({ default: '' })
  private user_id!: string;

  @Prop({ default: () => new Date() })
  private lesson_dt!: Date;

  private targets: PlanTarget[] = [];

  get shortTermPlans() {
    return this.targets.filter((p) => p.term_type === SupportPlanConst.SHORT_TERM);
  }

  get longTermPlans() {
    return this.targets.filter((p) => p.term_type === SupportPlanConst.LONG_TERM);
  }

  @Watch('user_id')
  private async loadData() {
    const biz = new SupportPlanService();
    const response = await biz.getPlanByDate(this.user_id, this.lesson_dt);
    this.targets = response.data;
  }
}
